export enum OrderTypeEnum {
    SAFEGUARD = "SAFEGUARD",
    SETTING = "SETTING",
    OPTION = "OPTION",
    PRODUCT = "PRODUCT",
    CONTRACT = "CONTRACT"
}

export enum OrderStatusTypeEnum {
    CANCELED = "CANCELED",
    PENDING = "PENDING",
    QUEUED = "QUEUED",
    FAILED = "FAILED",
    SUCCESS = "SUCCESS"
}

export enum OrderErrorTypeEnum {
    ERROR_JSON = "JSON_ERROR",
    ERROR_HTML = "HTML_ERROR",
    ERROR_TEXT = "TEXT_ERROR",
    ERROR_DEBT = "CUSTOMER_DEBT"
}